module.exports = __webpack_public_path__ + "assets/img/melt_chocolate_active.73a120dd.png";